import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchDashboardData } from '../../services/api';
import { Chart as ChartJS } from "chart.js/auto";
import { Line, Doughnut } from "react-chartjs-2";
import '../../styles/output.css';
import '../../styles/index.css';
import { SideMenu, Header } from 'maxcu-shared-lib';
import menuItems from '../SideMenu/menuItems';

function RewardsFeed() {

  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    let isMounted = true;

    const getData = async () => {
      try {
        const result = await fetchDashboardData();
        console.log('[RewardsFeed] fetchDashboardData result:', result);
        setTimeout(() => {
          if (isMounted){
            setData(result);
          }
        },500);
        
      } catch (err) {
        if (isMounted){
          setError(err);
        }
      }
    };
    getData();

    return () => {
      isMounted=false;
    };
  }, []);

  return (
    <div style={{ display: 'flex' }}>
      <SideMenu menuItems={menuItems} />
      <div style={{ flex: 1 }}>
      <Header name="Rewards Feed" />
      {/* potential to have a chart: https://www.youtube.com/watch?v=6q5d3Z1-5kQ */}
      { data?.rewards_feed ? (
        <div className="mx-auto sm:max-w-3xl sm:grid sm:grid-cols-2 sm:gap-4 mb-2 sm:mb-4">
          {/* START REWARDS FEED SECTION */}
          <div>
                    <h2 className="text-h2-feed text-xl font-bold leading-normal text-gray-800 mb-2">Feed Details</h2>
                    <p className="text-sm">The rewards feed shows a monthly summary of points earned, redemptions, and referral points earned. </p>
                    <div className="flow-root mt-6">
                    { data.rewards_feed ? (
                        <ul role="list" className="-mb-8">
                          {Object.entries(data.rewards_feed)
                              .slice(0,10)
                              .map(([itemKey, itemData], index, array) => (
                                <li key={itemKey} className="w-full">
                                  {itemData.type === 'earned' ? (
                                    <div className="relative pb-8 bg-emerald-100 rounded-md p-4 mb-2">
                                    <div className="relative flex space-x-3">
                                            <div className="pt-1.5">
                                              <div>
                                                <p className="p-feed-details color-white text-gray-600"><strong>You earned <strong className="text-green-600">+{itemData.points} points</strong> in {itemData.description}</strong>
                                                <br /><br />
                                                {Object.entries(itemData.details)
                                                  .map(([subItemKey, subItemData]) => (
                                                    <span>
                                                    <small>{subItemData.line } </small><br />
                                                    </span>
                                                  ))}
                                                </p>
                                              </div>
                                            </div>
                                      </div>
                                    </div>

                                  ) : itemData.type === 'adhoc' ? (
                                  <div className="relative pb-8 bg-green-100 rounded-md p-4 mb-2">
                                    <div className="relative flex space-x-3">
                                            <div className="pt-1.5">
                                              <div>
                                                <p className="p-feed-details color-white text-sm text-gray-600"><strong>You earned <strong className="text-green-600">+{itemData.points} points</strong> {itemData.description}</strong>
                                                <br />
                                                {Object.entries(itemData.details)
                                                  .map(([subItemKey, subItemData]) => (
                                                    <span className='span-feed-details'>
                                                    <small>{subItemData.line } </small><br />
                                                    </span>
                                                  ))}
                                                </p>
                                              </div>
                                            </div>
                                      </div>
                                    </div>

                                  )  : itemData.type === 'redeem' ? (
                                    <div className="relative pb-8 bg-blue-100 rounded-md p-4 mb-2">
                                      <div className="relative flex space-x-3">
                                              <div className="pt-1.5">
                                                <div>
                                                  <p className="color-white text-sm text-gray-600"><strong>You redeemed <strong className="text-blue-600">-{itemData.points} points</strong> for {itemData.description} on {itemData.date}</strong>
                                                  </p>
                                                </div>
                                              </div>
                                        </div>
                                      </div>
                                    )  : itemData.type === 'referral' ? (
                                      <div className="relative pb-8 bg-gray-100 rounded-md p-4 mb-2">
                                        <div className="relative flex space-x-3">
                                                <div className="pt-1.5">
                                                  <div>
                                                    <p className="color-white text-sm text-gray-600">You referred {itemData.description}
                                                    </p>
                                                  </div>
                                                </div>
                                          </div>
                                        </div>
                                    )  : itemData.type === 'referral_complete' ? (
                                      <div className="relative pb-8 bg-gray-100 rounded-md p-4 mb-2">
                                        <div className="relative flex space-x-3">
                                                <div className="pt-1.5">
                                                  <div>
                                                    <p className="color-white text-sm text-gray-600">You and {itemData.description} both earned <strong className="text-green-600">+{itemData.points} points</strong>
                                                    </p>
                                                  </div>
                                                </div>
                                          </div>
                                        </div>

                                    )  : itemData.type === 'donate' ? (
                                      <div className="relative pb-8 bg-blue-100 rounded-md p-4 mb-2">
                                        <div className="relative flex space-x-3">
                                                <div className="pt-1.5">
                                                  <div>
                                                    <p className="color-white text-sm text-gray-600">You donated <strong className="text-blue-600">{itemData.points} points</strong> to {itemData.description}
                                                    </p>
                                                  </div>
                                                </div>
                                          </div>
                                        </div>

                                    ) : itemData.type === 'promo' ? (
                                      <div className="relative pb-8 bg-green-100 rounded-md p-4 mb-2">
                                        <div className="relative flex space-x-3">
                                          <div className="pt-1.5">
                                            <div>
                                              <p className="p-feed-details color-white text-sm text-gray-600"><strong>You earned <strong className="text-green-600">+{itemData.points} points</strong> for {itemData.description} code</strong></p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ) : (
                                    <span>&nbsp;</span>
                                  )}
                                  
                                </li>
                              ))}
                        </ul>
                    ) : (
                      <p className="text-sm"><i>Points are added at the end of each month.<br />Check back again soon.</i></p>

                    )}

                        </div>
                    </div>       
                   {/* END REWARDS FEED SECTION */}

           
        
         </div>
      ) : (
        <div>
          Loading...
        </div>
      )}

        

      </div>
    </div>
  );
}

export default RewardsFeed;